import React, { useState, useEffect, useRef } from "react"
import ConsentForm from "./ConsentForm"
import CanvasImageZone from "./ImageCanvasZone"
import LoadingContainer from "components/Spinner2"

const EditStage = ({ onLoad, frame, userUpload = null, onPhotoSaved, photoSaved, onGotoGallery, saveConsentRequired, galleryButtonText = "Go to gallery", onUploadNewImage, legalText, children, onChangePhotoInEditStage, editingUserImage, isActive, shareIcons }) => {
  const [consentGiven, setConsentGiven] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const editorRef = useRef(null)

  useEffect(() => {
    if (onLoad) {
      onLoad()
    }
  }, [])

  const doPhotoSave = async () => {
    setIsLoading(true)
    let thedata = await editorRef.current.exportDataURL()
    await onPhotoSaved(thedata)
    setIsLoading(false)
  }
  const handleConsentChanged = resp => {
    setConsentGiven(resp)
  }
  const isSaveDisabled = () => {
    return false
  }
  return (
    <div className={`edit-stage ${photoSaved !== null ? "is-saved-stage" : ""}`}>
      <LoadingContainer condition={isLoading}>
        <div className={`fabric-canvas-container`}>
          {/* When the user is editing the uploaded image in the canvas */}
          {editingUserImage === false && photoSaved === null && <>{isActive && <CanvasImageZone ref={editorRef} id={"fabric-js"} overlayImg={frame && frame.image && frame.image.id} backgroundColor={frame && frame.bgColor} activeImg={userUpload} onChangePhoto={onChangePhotoInEditStage} />}</>}
          {/* When the user selects the camera image and reselects the upload function. */}
          {editingUserImage === true && <div className={`editing-user-image`}>{children}</div>}
          {/* if photo saved successfully, final save shown here. */}
          {photoSaved !== null && (
            <div className={`saved-photo`}>
              <img className={`final-saved-image`} src={photoSaved} />
            </div>
          )}
        </div>
        <div className={`button-container`}>
          {/* show legal text and consent form if needed. */}
          {saveConsentRequired === true && photoSaved === null && <ConsentForm onConsentChanged={handleConsentChanged} legalText={legalText} />}
          {/* If the image edit is yet to be saved, show save button and (if applicable) legal text */}
          {photoSaved === null && (
            <button className={`btn ${saveConsentRequired === true && consentGiven === false ? `is--disabled` : "is-not-disabled"}`} title={`${saveConsentRequired === true && consentGiven === false ? "Please check the button below to save." : ""}`} onClick={() => doPhotoSave()} disabled={saveConsentRequired === true && consentGiven === false}>
              Save
            </button>
          )}

          {/* Show*/}
          {photoSaved !== null && (
            <div className={`photo-saved-dialogue`}>
              <button className="btn gallery-button" onClick={() => onGotoGallery()}>
                {galleryButtonText}
              </button>
              {shareIcons && (
                <>
                  <span className="or">or</span>
                  <p>Share with friends and family</p>
                  <div className={`photo-saved-social`}>{shareIcons}</div>
                </>
              )}
            </div>
          )}
        </div>
      </LoadingContainer>
    </div>
  )
}

export default EditStage
